import { render, staticRenderFns } from "./OrderPageLayout.vue?vue&type=template&id=af6834c4&"
import script from "./OrderPageLayout.vue?vue&type=script&lang=ts&"
export * from "./OrderPageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBtnToggle,QCard,QCardSection,QBtnDropdown} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtnToggle,QCard,QCardSection,QBtnDropdown})
